import React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";
import Header from "../../Layouts/Header";
import Loading from "../../Layouts/Loading";

import InvitePic from "../../Assets/Images/invite.jpg";
import {TiChevronLeft} from "react-icons/ti";
import {useNavigate} from "react-router-dom";
import {TbArrowBadgeLeft} from "react-icons/tb";
import Toast from "../../Components/Toast";

const InviteOthers = () => {
    const navigate = useNavigate();

    const [user , setUser] = React.useState([]);
    const [ , setHasToken] = React.useState(false);
    const [isLoaded, setIsLoaded] = React.useState(false);
    const [mobile, setMobile] = React.useState('');
    const [buttonText, setButtonText] = React.useState('ارسال');
    const [loading, setLoading] = React.useState('d-none');
    const [buttonStatus, setButtonStatus] = React.useState("disabled");

    React.useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if(!token) {
            window.location.replace('/login')
        }
        else {
            setHasToken(true)
            setIsLoaded(false);

            API.getUserInfo()
                .then((response) => {
                    setIsLoaded(true);
                    setUser(response.data.user);
                })
                .catch((error) => {
                    if (error.response) {
                        toast.error(error.response.data.message);
                    } else {
                        toast.error(error.message);
                    }
                });
        }
    }, []);

    const share = () => {
        navigator.share({
            text: 'برای سفارش مستقیم از تامین کننده ها  اپلیکیشن پخش من را نصب کنید',
            url: `https://app.pakhshman.ir/invite/${user.code}`
        })
    }
    const share2 = () => {
        navigator.share({
            text: 'شما به سامانه پخش من دعوت شده اید. برای ثب نام در سامانه تامین کننده لینک زیر را لمس کنید',
            url: `https://s.pakhshman.ir/invite/${user.code}`
        })
    }

    const onMobileChange = (event) => {
        const mobile = event.target.value;
        if (mobile.length >= 12) {
            return false;
        }
        if (mobile[0] === '0' && mobile[1] === '9' && mobile.length === 11) {
            setButtonStatus("")
        } else {
            setButtonStatus("disabled")
        }
        setMobile(mobile);
    }

    /*    const onNameChange = (event) => {
            setName(event.target.value);
        }*/

    const onButtonClick =  () => {
        setButtonText("");
        setLoading("d-inline-block");
        setButtonStatus("disabled");

        const request = {
            mobile: mobile,
            // name: name,
            code: user.code
        }

        API.sendInviteSMS(request)
            .then((response) => {
                toast.success(response.message);
                setButtonText("ادامه");
                setLoading("d-none")
                setButtonStatus('')
                setMobile('')

            })
            .catch((error) => {
                toast.error(error.response.data.message)
                setButtonText("ادامه");
                setLoading("d-none")
                setButtonStatus('')
            });
    }

    return (
        <React.Fragment>
            <Toast />
            <Header title=' دعوت از دیگران' hasBack={true} />
            {
                !isLoaded && <Loading />
            }

            <main className="container-fluid ">
                <div className="row px-3 ">

                    <div className="col-12 ">
                        <img src={InvitePic} alt="پخش من" className="rounded mx-auto d-block mt-5 w-100"/>
                    </div>
                    <div className="col-12 mb-5 px-4 pt-3 rtl text-justify border rounded text-small-3">
                        با معرفی اپلیکیشن پخش من به دیگران می توانید از سفارش هایی که توسط افراد معرفی شده توسط شما
                        انجام می شود پورسانت دریافت کنید
                        <div className="row alert alert-success  text-center fw-bold mt-4"
                             onClick={() => navigate('/reagents')}
                        >
                            <div className="col-7">
                                تعداد افراد معرفی شده :
                            </div>
                            <div className="col-4 text-start">
                                {user.reagent_count}
                                &nbsp;
                                نفر
                            </div>
                            <div className="col-1">
                                <TiChevronLeft className=' text-big-4'/>
                            </div>
                        </div>
                        <div className="row alert alert-warning  text-center fw-bold mt-4"
                             onClick={() => navigate('/reagent-vendors')}
                        >
                            <div className="col-7">
                                تعداد شرکت معرفی شده:
                            </div>
                            <div className="col-4 text-start">
                                {user.vendor_reagent_count}
                                &nbsp;
                                تامین کننده
                            </div>
                            <div className="col-1">
                                <TiChevronLeft className=' text-big-4'/>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 rtl text-end text-small-2 fw-bold">
                        لینک اختصاصی شما برای دعوت مغازه داران به اپلیکیشن پخش من:
                    </div>
                    <div className='col-12'>
                        <div className='alert alert-success bg-success text-white p-1 mt-4 text-center'
                             onClick={share}
                        >
                            https://app.pakhshman.ir/invite/{user.code}
                        </div>
                    </div>

                    <div className="col-12 rtl mt-5 text-end text-small-2 fw-bold">
                        لینک اختصاصی شما برای دعوت تامین کنندگان به سامانه پخش من:
                    </div>
                    <div className='col-12'>
                        <div className='alert alert-warning bg-primary-color text-white p-1 mt-4 text-center'
                             onClick={share2}
                        >
                            https://s.pakhshman.ir/invite/{user.code}
                        </div>
                    </div>
                    <div className="row my-5 mx-3 px-2 bg-custom pb-5">
                        <div className="col-12 rtl text-end text-small-2 fw-bold text-success pt-3">
                            همچنین برای دعوت از دیگران می توانید شماره همراه آنها را وارد کرده و دکمه ارسال را بزنید
                        </div>

                        <div className="col-12 mt-3 ">

                            <div className="form-floating mb-3">
                                <input type="tel"
                                       className="form-control text-center text-big-2 "
                                       id="floatingInput"
                                       placeholder="شماره  موبایل"
                                       value={mobile}
                                       onChange={onMobileChange}
                                />
                                <label htmlFor="floatingInput" className="end-0 text-secondary text-small-1 text-end">شماره
                                    موبایل</label>
                            </div>
                        </div>

                        <div className='col-12 mt-3'>
                            <button
                                className="btn btn-success text-center text-small-1 text-semi-big  w-100 p-2  pr-4 border-0"
                                onClick={onButtonClick}
                                disabled={buttonStatus}
                            >
                                {buttonText}
                                <span className="badge  p-2 float-start">
<TbArrowBadgeLeft className='text-big-3'/>
                    </span>
                                <span className={"spinner-grow spinner-grow-sm " + loading} role="status"
                                      aria-hidden="true">

                            </span>
                            </button>
                        </div>
                    </div>

                </div>
            </main>

        </React.Fragment>
    );
};

export default InviteOthers;